// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSaveProofTypeController from "./auto_save_proof_type_controller"
application.register("auto-save-proof-type", AutoSaveProofTypeController)

import AutoSaveStatusController from "./auto_save_status_controller"
application.register("auto-save-status", AutoSaveStatusController)

import ClassPictureSeasonController from "./class_picture_season_controller"
application.register("class-picture-season", ClassPictureSeasonController)

import DistrictFilterController from "./district_filter_controller"
application.register("district-filter", DistrictFilterController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import JobManagerController from "./job_manager_controller"
application.register("job-manager", JobManagerController)

import PostNewTabController from "./post_new_tab_controller"
application.register("post-new-tab", PostNewTabController)

import SeasonPickerController from "./season_picker_controller"
application.register("season-picker", SeasonPickerController)

import SeniorsFaqSearchController from "./seniors_faq_search_controller"
application.register("seniors-faq-search", SeniorsFaqSearchController)

import SeniorsGalleryController from "./seniors_gallery_controller"
application.register("seniors-gallery", SeniorsGalleryController)

import SeniorsPackagesController from "./seniors_packages_controller"
application.register("seniors-packages", SeniorsPackagesController)

import SeniorsStepController from "./seniors_step_controller"
application.register("seniors-step", SeniorsStepController)

import StatusPillController from "./status_pill_controller"
application.register("status-pill", StatusPillController)

import UpdateCountController from "./update_count_controller"
application.register("update-count", UpdateCountController)

import SchoolSearchController from "./school_search_controller"
application.register("school-search", SchoolSearchController)
